import React, { useContext, useEffect, useState } from 'react';
import './ProfileBox.css';
import { Account } from '../account';
import { getImageUrl, GLOBAL_COLORS } from '../../hooks';
import { AppDataContext } from '../../utils';
import { IBLSpinLoader } from '../IBLSpinLoader';
import { FaShareAlt, FaFacebookF } from 'react-icons/fa';
import { FaLinkedinIn, FaXTwitter } from 'react-icons/fa6';
import { LuPencil } from 'react-icons/lu';

const ProfileBox = () => {
  const { appData, setAppData } = useContext(AppDataContext);
  const [isFocused, setIsFocused] = React.useState(false);
  const [facebookUrl, setFacebookUrl] = useState('');
  const [linkedinUrl, setLinkedinUrl] = useState('');
  const [twitterUrl, setTwitterUrl] = useState('');
  const [socialEnabled, setSocialEnabled] = useState(true);

  const handleProfileBoxClick = () => {
    setIsFocused(!isFocused);
  };

  const populateSocialMediaLinks = () => {
    const socialLinks = appData.userMetaData?.social_links;
    if (Array.isArray(socialLinks) && socialLinks?.length > 0) {
      socialLinks.forEach(function (socialLink) {
        if (
          !socialLink?.social_link ||
          socialLink?.social_link === '' ||
          socialLink?.social_link === '#'
        ) {
          return;
        }
        const platform = socialLink?.platform;

        if (platform === 'linkedin') {
          setLinkedinUrl('https://linkedin.com/in/' + socialLink?.social_link);
        }
        if (platform === 'twitter') {
          setTwitterUrl('https://twitter.com/' + socialLink?.social_link);
        }

        if (platform === 'facebook') {
          setFacebookUrl('https://www.facebook.com/' + socialLink?.social_link);
        }
      });
    } else {
      setSocialEnabled(false);
    }
  };

  useEffect(() => {
    appData.userMetaDataLoaded && populateSocialMediaLinks();
  }, [appData.userMetaDataLoaded]);

  return (
    <>
      <div className="prof_box pp">
        {appData.userMetaDataLoaded ? (
          <>
            <div className="div-block-8">
              <img
                alt=""
                className="image-7"
                loading="lazy"
                src={getImageUrl(
                  appData.userMetaData?.profile_image?.image_url_full
                )}
              />
              <div className="w-layout-vflex flex-block-20">
                <div
                  onClick={() => handleProfileBoxClick()}
                  className="div-block-3"
                >
                  <div className="text-block">{appData.userMetaData?.name}</div>
                </div>
                <div>{appData.userMetaData?.bio}</div>
              </div>
            </div>
            {/*TODO : the share button is not working*/}
            <div className="div-block-161 edit_profile_trigger home">
              <a className="w-inline-block">
                <LuPencil
                  color={GLOBAL_COLORS.icon_color}
                  className={'image-24 home'}
                  onClick={() => handleProfileBoxClick()}
                />
                {/*<img
                  alt=""
                  className="image-24 home"
                  loading="lazy"
                  sizes="(max-width: 991px) 14px, 1vw"
                  src="images/ph.png"
                  srcSet="images/ph-p-500.png 500w, images/ph.png 512w"
                  onClick={handleProfileBoxClick}
                />*/}
                <img
                  alt=""
                  className="ph"
                  loading="lazy"
                  sizes="100vw"
                  src="images/62a1d40ebd16fee404a1d732_pencil.png"
                  srcSet="images/62a1d40ebd16fee404a1d732_pencil-p-500.png 500w, images/62a1d40ebd16fee404a1d732_pencil.png 512w"
                />
              </a>
            </div>
            {socialEnabled && (
              <div className="w-layout-hflex flex-block-21">
                <a className="profile-pox-socials-link w-inline-block" href="#">
                  <FaShareAlt
                    className={'profile-pox-socials-link-icon'}
                    color={GLOBAL_COLORS.icon_color}
                  />
                  {/*<img
                    alt=""
                    className="profile-pox-socials-link-icon"
                    loading="lazy"
                    src="images/share0_1share0.png"
                  />*/}
                </a>
                {!['', '#'].includes(facebookUrl) && (
                  <a
                    className="profile-pox-socials-link w-inline-block"
                    href={facebookUrl}
                  >
                    <FaFacebookF
                      className={'profile-pox-socials-link-icon'}
                      color={GLOBAL_COLORS.icon_color}
                    />
                    {/*<img
                      alt=""
                      className="profile-pox-socials-link-icon"
                      loading="lazy"
                      sizes="(max-width: 767px) 18px, (max-width: 991px) 2vw, (max-width: 1279px) 18px, 1vw"
                      src="images/facebook-1_2.png"
                      srcSet="images/facebook-1_2-p-500.png 500w, images/facebook-1_2.png 512w"
                    />*/}
                  </a>
                )}
                {!['', '#'].includes(linkedinUrl) && (
                  <a
                    className="profile-pox-socials-link w-inline-block"
                    href={linkedinUrl}
                  >
                    <FaLinkedinIn
                      className={'profile-pox-socials-link-icon'}
                      color={GLOBAL_COLORS.icon_color}
                    />
                    {/*<img
                      alt=""
                      className="profile-pox-socials-link-icon"
                      loading="lazy"
                      sizes="(max-width: 767px) 18px, (max-width: 991px) 2vw, (max-width: 1279px) 18px, 1vw"
                      src="images/lk0.png"
                      srcSet="images/linkedin-2-p-500.png 500w, images/lk0.png 512w"
                    />*/}
                  </a>
                )}

                {!['', '#'].includes(twitterUrl) && (
                  <a
                    className="profile-pox-socials-link w-inline-block"
                    href={twitterUrl}
                  >
                    <FaXTwitter
                      className={'profile-pox-socials-link-icon'}
                      color={GLOBAL_COLORS.icon_color}
                    />
                  </a>
                )}
              </div>
            )}
          </>
        ) : (
          <IBLSpinLoader size={40} containerHeight={'100px'} />
        )}
      </div>
      {appData.userMetaDataLoaded && isFocused && (
        <Account onModalClose={() => setIsFocused(false)} />
      )}
    </>
  );
};

export { ProfileBox };
